import React from 'react';
import styles from './TrustProofSection.module.css';

const proofPoints = [
  {
    value: 'Source-Linked',
    label: 'Record',
    detail: 'Every conclusion stays tied to the record'
  },
  {
    value: 'Human Review',
    label: 'Acceptance',
    detail: 'AI-assisted content enters only after analyst approval'
  },
  {
    value: 'Diligence Gaps',
    label: 'Visible',
    detail: 'Missing inputs and assumptions remain reviewable'
  },
  {
    value: 'Committee-Ready',
    label: 'Artifacts',
    detail: 'Risk register, diligence agenda, and report workspace'
  }
];

const TrustProofSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.proofGrid}>
          {proofPoints.map((point, index) => (
            <div key={index} className={styles.proofItem}>
              <span className={styles.proofValue}>{point.value}</span>
              <span className={styles.proofLabel}>{point.label}</span>
              <span className={styles.proofDetail}>{point.detail}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustProofSection;
